import { render, staticRenderFns } from "./DialogPrompt.vue?vue&type=template&id=958a4ec8&"
import script from "./DialogPrompt.vue?vue&type=script&lang=js&"
export * from "./DialogPrompt.vue?vue&type=script&lang=js&"
import style0 from "./DialogPrompt.vue?vue&type=style&index=0&id=958a4ec8&prod&scss=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.defietsambassadegent/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton, BModal} from 'bootstrap-vue'
    installComponents(component, {BButton, BModal})
    

export default component.exports